/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DryRunEvent } from './DryRunEvent';
import {
    DryRunEventFromJSON,
    DryRunEventFromJSONTyped,
    DryRunEventToJSON,
    DryRunEventToJSONTyped,
} from './DryRunEvent';
import type { DryRunTransition } from './DryRunTransition';
import {
    DryRunTransitionFromJSON,
    DryRunTransitionFromJSONTyped,
    DryRunTransitionToJSON,
    DryRunTransitionToJSONTyped,
} from './DryRunTransition';

/**
 * The whole dry-run report: which transition fires, and which rule wins.
 * @export
 * @interface DryRunResponse
 */
export interface DryRunResponse {
    /**
     * 
     * @type {DryRunEvent}
     * @memberof DryRunResponse
     */
    event: DryRunEvent;
    /**
     * 
     * @type {string}
     * @memberof DryRunResponse
     */
    fires: string | null;
    /**
     * 
     * @type {Array<DryRunTransition>}
     * @memberof DryRunResponse
     */
    evaluated: Array<DryRunTransition>;
}

/**
 * Check if a given object implements the DryRunResponse interface.
 */
export function instanceOfDryRunResponse(value: object): value is DryRunResponse {
    if (!('event' in value) || value['event'] === undefined) return false;
    if (!('fires' in value) || value['fires'] === undefined) return false;
    if (!('evaluated' in value) || value['evaluated'] === undefined) return false;
    return true;
}

export function DryRunResponseFromJSON(json: any): DryRunResponse {
    return DryRunResponseFromJSONTyped(json, false);
}

export function DryRunResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DryRunResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'event': DryRunEventFromJSON(json['event']),
        'fires': json['fires'],
        'evaluated': ((json['evaluated'] as Array<any>).map(DryRunTransitionFromJSON)),
    };
}

export function DryRunResponseToJSON(json: any): DryRunResponse {
    return DryRunResponseToJSONTyped(json, false);
}

export function DryRunResponseToJSONTyped(value?: DryRunResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'event': DryRunEventToJSON(value['event']),
        'fires': value['fires'],
        'evaluated': ((value['evaluated'] as Array<any>).map(DryRunTransitionToJSON)),
    };
}

